<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app clipped :permanent="$vuetify.breakpoint.lg">
      <v-list dense shaped>
        <v-list-item-group v-model="nav_model" mandatory>
          <v-list-item @click="openOverview" link>
            <v-list-item-action>
              <i class="fal fa-list"></i>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t("general.overview") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="openArchive" link>
            <v-list-item-action>
              <i class="fal fa-inbox-in"></i>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t("general.archive") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="openSettings" link>
            <v-list-item-action>
              <i class="fal fa-cog"></i>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t("general.settings") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
        <v-divider></v-divider>
        <v-list-item>
          <v-list-item-action>
            <v-switch v-model="isDark"></v-switch>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("general.dark_mode") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app clipped-left>
      <v-app-bar-nav-icon v-if="!$vuetify.breakpoint.lg" @click.stop="drawer = !drawer" />
      <img
        src="https://tasks.schmuckli.dev/apple-icon.png"
        width="30"
        height="30"
        alt="Tasks"
        style="margin-right:10px;"
      />
      <v-toolbar-title>{{ $t('general.app_name') }}</v-toolbar-title>
    </v-app-bar>

    <v-content>
      <v-container class fluid>
        <transition name="fale" mode="out-in">
          <router-view />
        </transition>
      </v-container>
    </v-content>

    <!--<v-footer app>
      <span>&copy; 2019</span>
    </v-footer>-->
    <!-- Notification -->
    <v-snackbar v-model="notification">
      {{ notification_text }}
      <v-btn depressed @click="notification = ''">{{ $t("general.close") }}</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import {
  Notifications,
  NotificationsReceiver,
  PushNotification
} from "./notification";
import { auth, storage } from "./schmucklicloud";

export default {
  props: {
    source: String
  },
  data: () => ({
    drawer: null,
    isDark:
      localStorage.getItem("isDark") === undefined
        ? false
        : localStorage.getItem("isDark") === "true"
        ? true
        : false,
    nav_model: 0
  }),
  methods: {
    openOverview() {
      this.$router.push("/");
    },
    openSettings() {
      this.$router.push("/settings");
    },
    openArchive() {
      this.$router.push("/archive");
    },
    setupMessaging() {
      PushNotification.setup();
    }
  },
  created() {
    this.$vuetify.theme.dark = this.isDark;
  },
  async mounted() {
    var session_token = localStorage.getItem("session_token");
    var response = await auth.checkSession(session_token);
    if (response.status_code !== 200) {
      this.$router.replace("/login");
    } else {
      storage.setAuthToken(session_token);
      setTimeout(this.setupMessaging, 3000);
    }
  },
  watch: {
    isDark() {
      localStorage.setItem("isDark", this.isDark);
      this.$vuetify.theme.dark = this.isDark;
    },
    $route(to) {
      switch (to.path) {
        case "/settings":
          this.nav_model = 2;
          break;
        case "/archive":
          this.nav_model = 1;
          break;
        default:
          this.nav_model = 0;
      }
    }
  },
  computed: {
    /* Notification */
    notification: {
      get() {
        return NotificationsReceiver.notification !== "";
      },
      set() {
        Notifications.show("");
      }
    },
    notification_text() {
      return NotificationsReceiver.notification;
    }
  }
};
</script>

<style>
@import url("./assets/css/layout.css");
</style>